import Repository from "./Repository";
import TenantCreate from "../types/TenantCreate";

const resource = "/tenant";

export default {
  get() {
    return Repository.get(`${resource}`);
  },
  getOne(id: string) {
    return Repository.get(`${resource}/${id}`);
  },
  create(tenant: TenantCreate) {
    return Repository.post(`${resource}`, tenant);
  }
};
